class ClickHandler {
    constructor() {
        document.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
        const modal = document.querySelector('.modal-container-ex');
        const modalContent = document.querySelector('.modal-content-wrapper');

        if (event.target.matches('.trigger-open') || event.target.closest('.trigger-open')) {
            const wrapperContainer = event.target.closest('.description-wrapper-container');
            const descriptionContainer = wrapperContainer.querySelector('.modal-content-to-render');

            if (descriptionContainer && modal) {
                modal.classList.remove('modal-hide-x');
                modal.classList.add('modal-show-x');
                modalContent.innerHTML = descriptionContainer.innerHTML;
            }
        }

        if (event.target.matches('.modal-close-trigger-x') || event.target.closest('.modal-close-icon')) {
            if (modal) {
                modal.classList.remove('modal-show-x');
                modal.classList.add('modal-hide-x');
                modalContent.innerHTML = '';
            }
        }
    }
}

const clickHandler = new ClickHandler();
